// Schema: SurveyForm (verified against SCHEMA_REFERENCE.json).
export const INSERT_SURVEY_FORM_MUTATION = `
  mutation InsertSurveyForm($input: SurveyFormInsertInput!) {
    insertSurveyForm(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_SURVEY_FORM_MUTATION = `
  mutation UpdateSurveyForm($filter: String!, $input: SurveyFormUpdateInput!) {
    updateSurveyForm(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_SURVEY_FORM_MUTATION = `
  mutation DeleteSurveyForm($filter: String!, $input: SurveyFormDeleteInput!) {
    deleteSurveyForm(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
